import React from 'react';
import T from 'prop-types';

export const ProcessingToastContent = ({ name }) => (
  <p>Your export{name ? `, ${name},` : ''} has been started. We will notify you when complete.</p>
);

ProcessingToastContent.propTypes = {
  name: T.string,
};
